import axios, { AxiosResponse } from 'axios'

import gql from '../../utils/gql'
import getStoreName from '../../utils/getStoreName'
import getBearerToken from '../../utils/getBearerToken'

interface SetOrderSubscriptionRenewalStatusInterface {
  data: {
    addAdditionalDataToQuoteItem: {
      cart_id: string
      item_uid: string
      renewal_status: boolean
    }
  }
}

export const OrderSubscriptionRenewalStatusMutation = gql`
  mutation AddAdditionalDataToQuoteItem(
    $input: AddAdditionalDataToQuoteItemInput!
  ) {
    addAdditionalDataToQuoteItem(input: $input) {
      cart_id
      item_uid
      renewal_status
    }
  }
`

/**
 * @throws {string} Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const setOrderSubscriptionRenewalStatus = async (
  cart: string,
  item: string,
  autoRenewal: boolean,
): Promise<Record<string, unknown>> => {
  const bearerToken = getBearerToken()

  try {
    const { data }: AxiosResponse<SetOrderSubscriptionRenewalStatusInterface> =
      await axios({
        method: 'POST',
        url: process.env.MIX_MAGENTO_GRAPHQL,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${bearerToken}`,
          Store: getStoreName(),
        },
        data: {
          query: OrderSubscriptionRenewalStatusMutation,
          variables: {
            input: {
              cart_id: cart,
              item_uid: item,
              renewal_status: autoRenewal,
            },
          },
        },
      })
    if (data?.data?.addAdditionalDataToQuoteItem) {
      return data.data.addAdditionalDataToQuoteItem
    } else {
      console.error('Unexpected response structure:', data)
      return { data }
    }
  } catch (error) {
    console.error('Error with Status Response:', error)
    return { error }
  }
}
